/* ============================================
   SPOUT V4 — THEME JS
   Staggered reveals, smooth animations
   ============================================ */

(function() {
  'use strict';

  /* ---------- Staggered Scroll Reveal (all reveal variants) ---------- */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.reveal, .reveal-blur, .reveal-scale, .reveal-left, .reveal-right');
    if (!reveals.length) return;

    // Group reveals by their parent section/container
    var sections = new Map();
    reveals.forEach(function(el) {
      var parent = el.closest('section, .social-proof-bar, .hero-content, .test-grid, .press-quotes, .lab-results-grid, .benefits-grid, .steps-grid, .problem-stats, .wq-stats, .faq-list, .values-grid, .awards-row, .calc-results, .calc-inputs, .lifestyle-split-text, .use-cases-grid, .customer-wall, .comparison-grid');
      if (!parent) parent = el.parentElement;
      if (!sections.has(parent)) {
        sections.set(parent, []);
      }
      sections.get(parent).push(el);
    });

    // Assign stagger delay indices within each group
    sections.forEach(function(children) {
      children.forEach(function(el, i) {
        if (i > 0 && !el.getAttribute('data-delay')) {
          el.setAttribute('data-delay', Math.min(i, 10));
        }
      });
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    reveals.forEach(function(el) { observer.observe(el); });
  }

  /* ---------- Animated Counter (numbers count up on scroll) ---------- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    function animateCount(el) {
      var target = el.getAttribute('data-count');
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      var isFloat = target.indexOf('.') !== -1;
      var end = parseFloat(target);
      var duration = 2000;
      var startTime = null;

      function easeOutExpo(t) {
        return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var easedProgress = easeOutExpo(progress);
        var current = easedProgress * end;

        if (isFloat) {
          el.textContent = prefix + current.toFixed(1) + suffix;
        } else {
          el.textContent = prefix + Math.floor(current).toLocaleString() + suffix;
        }

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  /* ---------- Parallax on Scroll ---------- */
  function initParallax() {
    if (window.innerWidth <= 900) return; /* disable parallax on mobile */
    var elements = document.querySelectorAll('.parallax-img');
    if (!elements.length) return;

    function updateParallax() {
      var scrollTop = window.pageYOffset;
      elements.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute('data-speed')) || 0.15;
        var center = rect.top + rect.height / 2;
        var viewCenter = window.innerHeight / 2;
        var offset = (center - viewCenter) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    }

    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }

  /* ---------- Scroll Zoom (lifestyle images grow on scroll) ---------- */
  function initScrollZoom() {
    var zooms = document.querySelectorAll('.scroll-zoom');
    if (!zooms.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        } else {
          entry.target.classList.remove('in-view');
        }
      });
    }, { threshold: 0.2 });

    zooms.forEach(function(el) { observer.observe(el); });
  }

  /* ---------- Announcement Bar ---------- */
  function initAnnouncementBar() {
    var bar = document.querySelector('.announce-bar');
    if (!bar) return;
    var nav = document.querySelector('.nav');
    var closeBtn = bar.querySelector('.close-btn');

    function hideBar() {
      bar.style.display = 'none';
      document.documentElement.style.setProperty('--announce-height', '0px');
      if (nav) nav.classList.add('no-announce');
      sessionStorage.setItem('spout_announce_closed', '1');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', hideBar);
    }

    if (sessionStorage.getItem('spout_announce_closed') === '1') {
      hideBar();
      return;
    }

    // Slide nav to top when scrolled past announcement bar
    if (nav) {
      var barHeight = bar.offsetHeight;
      window.addEventListener('scroll', function() {
        if (window.scrollY >= barHeight) {
          nav.classList.add('no-announce');
        } else {
          nav.classList.remove('no-announce');
        }
      }, { passive: true });
    }
  }

  /* ---------- Countdown Timer ---------- */
  function initCountdown() {
    var el = document.getElementById('countdown-timer');
    if (!el) return;
    var endDate = el.dataset.end;
    if (!endDate) return;
    var end = new Date(endDate + 'T23:59:59').getTime();

    function update() {
      var now = Date.now();
      var diff = end - now;

      // Clear existing children
      while (el.firstChild) el.removeChild(el.firstChild);

      if (diff <= 0) {
        var endSpan = document.createElement('span');
        endSpan.textContent = 'ENDING SOON';
        el.appendChild(endSpan);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var parts = [
        String(d).padStart(2, '0') + 'd',
        String(h).padStart(2, '0') + 'h',
        String(m).padStart(2, '0') + 'm',
        String(s).padStart(2, '0') + 's'
      ];
      parts.forEach(function(text) {
        var span = document.createElement('span');
        span.textContent = text;
        el.appendChild(span);
      });
    }
    update();
    setInterval(update, 1000);
  }

  /* ---------- Mobile Menu ---------- */
  function initMobileMenu() {
    var hamburger = document.querySelector('.nav-hamburger');
    var menu = document.querySelector('.nav-mobile-menu');
    if (!hamburger || !menu) return;

    var menuOpen = false;
    var scrollY = 0;

    /* Block touch-scrolling everywhere EXCEPT inside the menu */
    document.addEventListener('touchmove', function(e) {
      if (!menuOpen) return;
      if (menu.contains(e.target)) return;  /* allow menu scroll */
      e.preventDefault();
    }, { passive: false });

    function lockBody() {
      scrollY = window.scrollY;
      menuOpen = true;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      menu.scrollTop = 0;
    }
    function unlockBody() {
      menuOpen = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('open');
      menu.classList.toggle('open');
      if (menu.classList.contains('open')) { lockBody(); } else { unlockBody(); }
    });
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        hamburger.classList.remove('open');
        menu.classList.remove('open');
        unlockBody();
      });
    });
  }

  /* ---------- FAQ Accordion ---------- */
  function initFAQ() {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function(item) {
      var question = item.querySelector('.faq-question');
      if (!question) return;
      question.addEventListener('click', function() {
        var wasOpen = item.classList.contains('open');
        items.forEach(function(i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  /* ---------- Review Modal ---------- */
  function initReviewModal() {
    var overlay = document.getElementById('reviewModal');
    if (!overlay) return;

    document.querySelectorAll('.test-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var stars = card.querySelector('.test-card-stars');
        var text = card.querySelector('.test-text');
        var name = card.querySelector('.test-name');
        var location = card.querySelector('.test-location');

        var modalStars = document.getElementById('modalStars');
        var modalText = document.getElementById('modalText');
        var modalName = document.getElementById('modalName');
        var modalLocation = document.getElementById('modalLocation');

        if (modalStars && stars) modalStars.textContent = stars.textContent;
        if (modalText && text) modalText.textContent = text.textContent;
        if (modalName && name) modalName.textContent = name.textContent;
        if (modalLocation && location) modalLocation.textContent = location.textContent;

        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('review-modal-close')) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Email Popup ---------- */
  function initEmailPopup() {
    var popup = document.querySelector('.email-popup-overlay');
    if (!popup) return;
    if (sessionStorage.getItem('spout_popup_shown') === '1') return;

    var shown = false;
    function showPopup() {
      if (shown) return;
      shown = true;
      popup.classList.add('active');
      sessionStorage.setItem('spout_popup_shown', '1');
    }

    document.addEventListener('mouseleave', function(e) {
      if (e.clientY < 10) showPopup();
    });

    if (window.innerWidth <= 900) {
      setTimeout(showPopup, 30000);
    }

    var closeBtn = popup.querySelector('.email-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('active');
      });
    }
    popup.addEventListener('click', function(e) {
      if (e.target === popup) popup.classList.remove('active');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('active')) {
        popup.classList.remove('active');
      }
    });
  }

  /* ---------- Hero Gallery (Homepage V4) — Click + Auto-cycle ---------- */
  function initHeroGallery() {
    var heroBgImg = document.querySelector('.hero-bg img');
    if (!heroBgImg) return;
    var thumbs = Array.from(document.querySelectorAll('.hero-thumb'));
    if (!thumbs.length) return;
    var taglines = Array.from(document.querySelectorAll('.hero-tagline'));
    var currentIdx = 0;
    var taglineIdx = 0;
    var autoTimer = null;
    var WORD_DELAY = 900; // slowed 20% from 750
    var WORD_STAGGER = WORD_DELAY * 0.55; // overlap: next word starts before previous finishes

    // Build word spans for each tagline using safe DOM methods
    taglines.forEach(function(tl) {
      var textData = tl.getAttribute('data-text');
      if (!textData) return;
      var lines = textData.split('|');
      // Clear existing content safely
      while (tl.firstChild) tl.removeChild(tl.firstChild);
      lines.forEach(function(line, li) {
        var words = line.trim().split(/\s+/);
        words.forEach(function(word, wi) {
          var span = document.createElement('span');
          span.className = 'tl-word';
          span.textContent = word;
          tl.appendChild(span);
          if (wi < words.length - 1) {
            tl.appendChild(document.createTextNode(' '));
          }
        });
        if (li < lines.length - 1) {
          var br = document.createElement('span');
          br.className = 'tl-br';
          tl.appendChild(br);
        }
      });
    });

    function animateWordsIn(tl) {
      var words = Array.from(tl.querySelectorAll('.tl-word'));
      words.forEach(function(w) { w.classList.remove('visible', 'hiding'); });
      words.forEach(function(w, i) {
        setTimeout(function() { w.classList.add('visible'); }, i * WORD_STAGGER);
      });
    }

    function animateWordsOut(tl, cb) {
      var words = Array.from(tl.querySelectorAll('.tl-word'));
      var total = words.length;
      words.forEach(function(w, i) {
        setTimeout(function() {
          w.classList.remove('visible');
          w.classList.add('hiding');
          if (i === total - 1 && cb) setTimeout(cb, 400);
        }, i * 100);
      });
    }

    // Calculate how long a tagline needs to fully display
    function getTaglineDuration(tl) {
      if (!tl) return 5000; // no tagline element: default 5s between thumb advances
      var wordCount = tl.querySelectorAll('.tl-word').length;
      return (wordCount * WORD_STAGGER) + WORD_DELAY + 2000; // stagger + last word duration + 2s hold
    }

    // Animate the first tagline on load
    var firstActive = taglines.find(function(t) { return t.classList.contains('active'); });
    if (firstActive) {
      setTimeout(function() { animateWordsIn(firstActive); }, 300);
    }

    function goTo(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      currentIdx = idx;
      var src = thumbs[idx].dataset.src;
      if (!src) return;
      heroBgImg.style.opacity = '0';
      var pos = thumbs[idx].dataset.pos || 'center';
      setTimeout(function() {
        heroBgImg.src = src;
        heroBgImg.style.objectPosition = pos;
        heroBgImg.style.opacity = '1';
      }, 350);
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumbs[idx].classList.add('active');

      // Rotate taglines independently — advance by 1 each time
      if (taglines.length > 1) {
        var oldTagline = taglines[taglineIdx];
        var newIdx = (taglineIdx + 1) % taglines.length;
        animateWordsOut(oldTagline, function() {
          oldTagline.classList.remove('active');
          taglineIdx = newIdx;
          taglines[taglineIdx].classList.add('active');
          animateWordsIn(taglines[taglineIdx]);
        });
      }
    }

    function startAuto() {
      stopAuto();
      var activeTl = taglines[taglineIdx] || taglines[0];
      var delay = getTaglineDuration(activeTl);
      autoTimer = setTimeout(function() {
        goTo(currentIdx + 1);
        startAuto();
      }, delay);
    }

    function stopAuto() {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    }

    // Click to switch + restart auto timer
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        goTo(i);
        startAuto(); // reset timer on manual click
      });
    });

    // Start auto-cycling
    startAuto();
  }

  /* Nav section message removed per request */
  function initNavSectionMsg() {}

  /* ---------- Payback Period Chart ---------- */
  function initPaybackChart() {
    var canvas = document.getElementById('paybackCanvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');

    // Make canvas crisp on retina
    var dpr = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = 260 * dpr;
    ctx.scale(dpr, dpr);
    var W = rect.width;
    var H = 260;

    var SPOUT_PRICE = 1495;
    var YEARS = 5;

    function draw(annualSpend, spoutAnnual) {
      if (!spoutAnnual && spoutAnnual !== 0) spoutAnnual = 198;
      var SPOUT_ANNUAL = spoutAnnual;
      if (annualSpend < 50) annualSpend = 50;
      ctx.clearRect(0, 0, W, H);

      var pad = { top: 48, right: 24, bottom: 36, left: 64 };
      var gW = W - pad.left - pad.right;
      var gH = H - pad.top - pad.bottom;

      // Calculate max Y
      var maxSpout = SPOUT_PRICE + (SPOUT_ANNUAL * YEARS);
      var maxOther = annualSpend * YEARS;
      var maxY = Math.max(maxSpout, maxOther) * 1.15;

      // Legend — centered above chart area
      ctx.font = '12px "DM Mono", monospace';
      var legendY = 18;
      var legendCenterX = pad.left + gW / 2;
      // Spout
      ctx.fillStyle = '#0FBBF1';
      ctx.fillRect(legendCenterX - 90, legendY - 4, 14, 3);
      ctx.textAlign = 'left';
      ctx.fillText('Spout', legendCenterX - 72, legendY);
      // Current
      ctx.fillStyle = '#FD527B';
      ctx.fillRect(legendCenterX + 20, legendY - 4, 14, 3);
      ctx.fillText('Current', legendCenterX + 40, legendY);

      // Grid lines — light mode colors
      ctx.strokeStyle = 'rgba(32,44,60,0.08)';
      ctx.lineWidth = 1;
      for (var g = 0; g <= 4; g++) {
        var gy = pad.top + gH - (gH * (g / 4));
        ctx.beginPath();
        ctx.moveTo(pad.left, gy);
        ctx.lineTo(W - pad.right, gy);
        ctx.stroke();
        // Y labels
        ctx.fillStyle = 'rgba(74,101,128,0.7)';
        ctx.font = '12px "DM Mono", monospace';
        ctx.textAlign = 'right';
        ctx.fillText('$' + Math.round((maxY * g / 4) / 100) * 100, pad.left - 10, gy + 3);
      }

      // X labels
      ctx.fillStyle = 'rgba(74,101,128,0.7)';
      ctx.textAlign = 'center';
      for (var yr = 0; yr <= YEARS; yr++) {
        var xx = pad.left + (gW * yr / YEARS);
        ctx.fillText('Y' + yr, xx, H - 8);
      }

      // Helper: x/y from year and cost
      function px(year) { return pad.left + (gW * year / YEARS); }
      function py(cost) { return pad.top + gH - (gH * cost / maxY); }

      // Current spending line (coral)
      ctx.beginPath();
      ctx.strokeStyle = '#FD527B';
      ctx.lineWidth = 2.5;
      ctx.setLineDash([]);
      for (var y1 = 0; y1 <= YEARS; y1++) {
        var cost1 = annualSpend * y1;
        if (y1 === 0) ctx.moveTo(px(y1), py(cost1));
        else ctx.lineTo(px(y1), py(cost1));
      }
      ctx.stroke();

      // Fill under current spending
      ctx.fillStyle = 'rgba(253,82,123,0.08)';
      ctx.beginPath();
      ctx.moveTo(px(0), py(0));
      for (var y1b = 0; y1b <= YEARS; y1b++) {
        ctx.lineTo(px(y1b), py(annualSpend * y1b));
      }
      ctx.lineTo(px(YEARS), py(0));
      ctx.closePath();
      ctx.fill();

      // Spout line (sky blue)
      ctx.beginPath();
      ctx.strokeStyle = '#0FBBF1';
      ctx.lineWidth = 2.5;
      for (var y2 = 0; y2 <= YEARS; y2++) {
        var cost2 = SPOUT_PRICE + (SPOUT_ANNUAL * y2);
        if (y2 === 0) ctx.moveTo(px(y2), py(SPOUT_PRICE));
        else ctx.lineTo(px(y2), py(cost2));
      }
      ctx.stroke();

      // Fill under Spout
      ctx.fillStyle = 'rgba(15,187,241,0.08)';
      ctx.beginPath();
      ctx.moveTo(px(0), py(0));
      ctx.lineTo(px(0), py(SPOUT_PRICE));
      for (var y2b = 1; y2b <= YEARS; y2b++) {
        ctx.lineTo(px(y2b), py(SPOUT_PRICE + SPOUT_ANNUAL * y2b));
      }
      ctx.lineTo(px(YEARS), py(0));
      ctx.closePath();
      ctx.fill();

      // Breakeven point
      if (annualSpend > SPOUT_ANNUAL) {
        var breakYears = SPOUT_PRICE / (annualSpend - SPOUT_ANNUAL);
        if (breakYears <= YEARS && breakYears > 0) {
          var bx = px(breakYears);
          var by = py(annualSpend * breakYears);
          ctx.beginPath();
          ctx.arc(bx, by, 5, 0, Math.PI * 2);
          ctx.fillStyle = '#00ECCC';
          ctx.fill();
          // Position label above or below dot, offset right to avoid line overlap
          ctx.fillStyle = '#00ECCC';
          ctx.font = '600 11px "DM Mono", monospace';
          ctx.textAlign = 'left';
          var labelY = by > pad.top + 30 ? by - 14 : by + 20;
          ctx.fillText('BREAKEVEN', bx + 10, labelY);
        }
      }
    }

    // Initial draw
    draw(1056, 198); // default: 12 bottles * 52 * 1.5 + 40*12; Spout = $99 filters every 6 months

    // Listen for calculator changes
    window.updatePaybackChart = draw;
  }

  /* ---------- Gallery (Product Page) ---------- */
  function initGallery() {
    var mainImg = document.getElementById('main-img');
    if (!mainImg) return;

    // Thumb switching
    document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.src || thumb.querySelector('img').src;
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 350);
        document.querySelectorAll('.gallery-thumb').forEach(function(t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
      });
    });

    // Lightbox — tap main image to enlarge
    var overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    var lbImg = document.createElement('img');
    lbImg.className = 'lightbox-img';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'lightbox-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00D7';
    overlay.appendChild(lbImg);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    // Swipe support
    var startX = 0;
    var thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
    var currentIdx = 0;

    function getActiveIdx() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('active')) return i;
      }
      return 0;
    }

    function showLightbox(src) {
      lbImg.src = src;
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      currentIdx = getActiveIdx();
    }

    function hideLightbox() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    function goToIdx(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      currentIdx = idx;
      var src = thumbs[idx].dataset.src || thumbs[idx].querySelector('img').src;
      lbImg.src = src;
      // Also update main gallery
      mainImg.src = src;
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumbs[idx].classList.add('active');
    }

    mainImg.addEventListener('click', function() {
      showLightbox(mainImg.src);
    });

    closeBtn.addEventListener('click', hideLightbox);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) hideLightbox();
    });

    overlay.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    overlay.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        goToIdx(currentIdx + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('active')) return;
      if (e.key === 'Escape') hideLightbox();
      if (e.key === 'ArrowLeft') goToIdx(currentIdx - 1);
      if (e.key === 'ArrowRight') goToIdx(currentIdx + 1);
    });
  }

  /* ---------- Hero Title + Image Rotator (disabled — static hero) ---------- */
  function initSubRotator() {}

  /* ---------- Init All ---------- */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initCounters();
    initParallax();
    initScrollZoom();
    initAnnouncementBar();
    initCountdown();
    initMobileMenu();
    initFAQ();
    initReviewModal();
    initEmailPopup();
    initHeroGallery();
    initGallery();
    initSubRotator();
    initNavSectionMsg();
    initPaybackChart();
  });

})();
